import React, { useMemo, useState }from "react";
import { Formik } from "formik"
import { TextField, Typography ,Button, Box, Checkbox, FormControlLabel} from '@material-ui/core';
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { useSignUpMutation, SignUpMutationVariables } from "../../generated/graphql";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Link } from "react-router-dom";
import { Space ,Spin, Modal } from "antd";

interface Props {}

const initialValues = {
    displayName: "",
    email: "",
    password: "",
};

const validationScheme = Yup.object().shape({
    displayName: Yup.string().required("This field is required"),
    email: Yup.string()
        .email("It should be an email").required("This field is required"),
        password: Yup.string().required("This field is required"),
});

// Warning modal config
const config = {
    title: 'Warning',
    content: (
        <> 
            <div>There was an issue signing up. Email may already be in use. Please try a different email or try again later.</div>
        </>
    ),
}


export const SignUp = (props: Props) => {
    const [signup, { loading }] = useSignUpMutation()
    const history = useHistory();
    const signupHandler = (values: SignUpMutationVariables) => {
        signup({variables: values}).then(({ errors }) => {
            if(errors) {
                alert("There was an issue signing up. Email may already be in use. Please try a different email or try again later.")
            } else {
                history.push("/signin");
            }
        }).catch((error) => {console.log(error); Modal.warning(config)});
    };
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

    const theme = useMemo(
      () =>
        createTheme({
          palette: {
            type: prefersDarkMode ? 'dark' : 'light',
          },
        }),
      [prefersDarkMode],
    );
    const [state, setState] = useState({
        checkedAge: false,
        checkedTerms: false,
    });
    const handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.log(event)
        setState({ ...state, [event.target.name]: event.target.checked });
    };
    

    return ( <ThemeProvider theme={theme}>
        <CssBaseline/>
        <Box width={300} margin="30px auto">
            <Typography style={{'color':'white'}} variant="h6"> Sign Up </Typography>
            <Formik
                initialValues={initialValues}
                validationScheme={validationScheme}
                onSubmit={signupHandler}
                >
                    {({
                        values,
                        touched,
                        errors,
                        isValid,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isInitialValid,
                    }) => 
                    <form onSubmit={handleSubmit}>
                        <TextField 
                            label="Email"
                            style={{'color':'white'}}
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            error={!!(errors.email && touched.email)}
                            helperText={
                                errors.email && touched.email && errors.email
                            }
                            margin="normal"
                        />
                         <TextField 
                            label="Password"
                            name="password"
                            style={{'color':'white'}}
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            type="password"
                            error={!!(errors.password && touched.password)}
                            helperText={
                                errors.password && touched.password && errors.password
                            }
                            margin="normal"
                        />
                        <br />
                        <br />
                        <FormControlLabel
                            control={ <Checkbox
                                checked={state.checkedAge}
                                name="checkedAge"
                                onChange={handleCheckBoxChange}
                                color="primary"
                            />}
                            label="I am over 21 years of age"
                        />
                        <br />
                        <br />
                        <FormControlLabel
                            control={ <Checkbox
                                checked={state.checkedTerms}
                                name="checkedTerms"
                                onChange={handleCheckBoxChange}
                                color="primary"
                            />}
                            label="I agree to B5inc's terms of service and privacy policy"
                        />
                        <br />
                        <br />
                      
                        <br />
                        <Button
                            fullWidth
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={ !state.checkedTerms || !state.checkedAge || loading}
                            >
                            Sign Up
                        </Button>  { loading ? (<Space  style={{width:"100%", margin: '0 auto', maxWidth: '1000px'}} size={2} direction="vertical" align="center">
                            <Spin />
                        </Space>): ''}
                        <br />
                        <br />
                        <br />
                        <a href="https://b5inc.com/privacy-policy" style={{color: "#8a9cff"}} target="_blank">Our privacy policy</a>
                        <br />
                        <a href="https://b5inc.com/terms-of-service" style={{color: "#8a9cff"}}  target="_blank">Our terms of service</a>
                        <br />
                        <br />
                    </form>
                    }
            </Formik>
            <br/>
            <br/>
            <br/>
            <span style={{width:'100%', display:'flex', flexDirection:'column', alignItems:"center"}}>
                <Typography style={{'color':'white'}} variant="h6">Already have an account? </Typography><br/>
                
                    <Link to='/signin'>
                        <Button variant="contained"
                                type="submit"
                                fullWidth
                                color="primary">
                            Sign in
                        </Button>
                    </Link> 
            </span>
        </Box>
        </ThemeProvider>
    )
}
